(function () {

  var SELECTOR = '[data-slideshow]';

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  var DESKTOP_QUERY = window.matchMedia && window.matchMedia('(min-width: 1200px)');



  if (window.AxiomSlideshow && typeof window.AxiomSlideshow.initAll === 'function') {

    window.AxiomSlideshow.initAll(document);

    return;

  }



  function formatNumber(value) {

    return String(value).padStart(2, '0');

  }



  function getSwiperAssets(root) {

    if (window.Swiper) return Promise.resolve(window.Swiper);

    if (window.Axiom && typeof window.Axiom.loadSwiperAssets === 'function') {

      return window.Axiom.loadSwiperAssets(root.dataset.swiperCss, root.dataset.swiperScript);

    }

    return Promise.reject(new Error('Swiper loader is unavailable.'));

  }



  function updatePagination(root, swiper) {

    var current = root.querySelector('[data-slideshow-current]');

    var activeIndex = swiper && Number.isFinite(swiper.realIndex) ? swiper.realIndex : 0;

    if (current) current.textContent = formatNumber(activeIndex + 1);

    root.querySelectorAll('[data-slideshow-pagination-dot]').forEach(function (dot, index) {

      dot.classList.toggle('is-active', index === activeIndex);

    });

  }



  function restartProgress(root) {

    var bar = root.querySelector('[data-slideshow-progress-bar]');

    if (!bar) return;

    bar.classList.remove('is-running');

    void bar.offsetWidth;

    if (root.classList.contains('is-autoplaying')) bar.classList.add('is-running');

  }



  function getSlideIndexByBlockId(root, blockId) {

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slideshow-slide]'));

    return slides.findIndex(function (slide) {

      return slide.dataset.blockId === blockId;

    });

  }



  function syncSlideVideos(root, swiper) {

    var reducedMotion = REDUCED_MOTION && REDUCED_MOTION.matches;

    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;



    root.querySelectorAll('[data-slideshow-slide] video').forEach(function (video) {

      var slide = video.closest('[data-slideshow-slide]');

      var isActive = slide && slide.classList.contains('swiper-slide-active');

      var isMobileVideo = video.classList.contains('slideshow__video--mobile');

      var hasMobileVideo = slide && slide.querySelector('.slideshow__video--mobile');

      var isVisibleMedia = mobile ? (isMobileVideo || !hasMobileVideo) : !isMobileVideo;



      if (reducedMotion || !isActive || !isVisibleMedia) {

        video.pause();

        return;

      }



      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});

    });

  }



  function bindCursorHint(root) {

    var hint = root.querySelector('[data-slideshow-cursor-hint]');

    var viewport = root.querySelector('[data-slideshow-swiper]') || root;

    if (!hint || root.dataset.slideshowCursorBound === 'true') return;

    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    if (REDUCED_MOTION && REDUCED_MOTION.matches) return;



    var frame = null;

    var pointer = { x: -100, y: -100 };

    var lastX = pointer.x;

    var lastY = pointer.y;

    var halfSize = 24;



    function renderCursor() {

      frame = null;

      if (pointer.x === lastX && pointer.y === lastY) return;

      lastX = pointer.x;

      lastY = pointer.y;

      hint.style.transform = 'translate3d(' + (pointer.x - halfSize) + 'px, ' + (pointer.y - halfSize) + 'px, 0)';

    }



    function requestCursorFrame() {

      if (frame) return;

      frame = window.requestAnimationFrame(renderCursor);

    }



    viewport.addEventListener('pointerenter', function (event) {

      pointer.x = event.clientX;

      pointer.y = event.clientY;

      renderCursor();

      root.classList.add('is-cursor-active');

    });



    viewport.addEventListener('pointermove', function (event) {

      pointer.x = event.clientX;

      pointer.y = event.clientY;

      requestCursorFrame();

    }, { passive: true });



    viewport.addEventListener('pointerleave', function () {

      root.classList.remove('is-cursor-active');

      root.classList.remove('is-cursor-pressed');

    });



    viewport.addEventListener('pointerdown', function () {

      root.classList.add('is-cursor-pressed');

    });



    viewport.addEventListener('pointerup', function () {

      root.classList.remove('is-cursor-pressed');

    });



    viewport.addEventListener('pointercancel', function () {

      root.classList.remove('is-cursor-pressed');

    });



    root.dataset.slideshowCursorBound = 'true';

  }



  function setupSlideDurations(root) {
    var fallback = parseInt(root.dataset.autoplayDelay, 10) || 11000;
    var durations = (root.dataset.slideDurations || '').split(',').map(function (value) {
      return parseInt(value, 10) || fallback;
    });
    var slides = root.querySelectorAll('[data-slideshow-slide]');
    slides.forEach(function (slide, index) {
      slide.setAttribute('data-swiper-autoplay', String(durations[index] || fallback));
    });
  }

  function syncSlideDuration(root, swiper) {
    if (!swiper || !swiper.slides) return;
    var active = swiper.slides[swiper.activeIndex];
    var duration = active && parseInt(active.getAttribute('data-swiper-autoplay'), 10);
    if (!duration) duration = parseInt(root.dataset.autoplayDelay, 10) || 11000;
    root.style.setProperty('--slideshow-autoplay-duration', duration + 'ms');
  }

  function initSlideshow(root) {

    if (!root || root.dataset.slideshowBound === 'true') return;



    var swiperElement = root.querySelector('[data-slideshow-swiper]');

    var slideCount = parseInt(root.dataset.slideshowCount, 10) || 0;

    if (!swiperElement || !slideCount) return;



    root.dataset.slideshowBound = 'true';

    bindCursorHint(root);



    getSwiperAssets(root).then(function () {

      if (!window.Swiper || root.dataset.slideshowDestroyed === 'true') return;



      var reducedMotion = REDUCED_MOTION && REDUCED_MOTION.matches;

      var designMode = root.dataset.designMode === 'true';

      var autoplayEnabled = root.dataset.autoplay === 'true' && !reducedMotion && !designMode && slideCount > 1;

      var delay = parseInt(root.dataset.autoplayDelay, 10) || 4000;

      var speed = reducedMotion ? 0 : parseInt(root.dataset.transitionSpeed, 10) || 1000;

      var isHorizontal = root.dataset.slideshowDirection === 'horizontal';

      var swiperConfig = {

        slidesPerView: 1,

        direction: 'horizontal',

        loop: slideCount > 1 && !designMode,

        parallax: false,

        speed: speed,

        watchSlidesProgress: false,

        keyboard: {

          enabled: true,

          onlyInViewport: true

        },

        autoplay: autoplayEnabled ? {

          delay: delay,

          disableOnInteraction: false

        } : false,

        on: {

          init: function (instance) {

            updatePagination(root, instance);

            syncSlideVideos(root, instance);

            syncSlideDuration(root, instance);
            restartProgress(root);

          },

          slideChangeTransitionEnd: function (instance) {

            updatePagination(root, instance);

            syncSlideVideos(root, instance);

            syncSlideDuration(root, instance);
            restartProgress(root);

          },

          slideChange: function (instance) {

            syncSlideDuration(root, instance);

            updatePagination(root, instance);

            syncSlideVideos(root, instance);

          },

          resize: function (instance) {

            updatePagination(root, instance);

            syncSlideVideos(root, instance);

          },

          breakpoint: function (instance) {

            updatePagination(root, instance);

            syncSlideVideos(root, instance);

          }

        }

      };



      if (!isHorizontal) {

        swiperConfig.breakpoints = {

          1200: {

            direction: 'vertical'

          }

        };

      }



      if (autoplayEnabled) root.classList.add('is-autoplaying');

      else root.classList.remove('is-autoplaying');



        setupSlideDurations(root);

      var swiper = new window.Swiper(swiperElement, swiperConfig);



      root._axiomSlideshow = swiper;
        syncSlideDuration(root, swiper);

      updatePagination(root, swiper);



      root.addEventListener('shopify:block:select', function (event) {

        var blockId = event.detail && event.detail.blockId;

        if (!blockId || !root._axiomSlideshow) return;



        var index = getSlideIndexByBlockId(root, blockId);

        if (index < 0) return;



        if (root._axiomSlideshow.autoplay) root._axiomSlideshow.autoplay.stop();

        root.classList.remove('is-autoplaying');

        restartProgress(root);

        if (root._axiomSlideshow.params.loop && typeof root._axiomSlideshow.slideToLoop === 'function') {

          root._axiomSlideshow.slideToLoop(index, 0);

        } else {

          root._axiomSlideshow.slideTo(index, 0);

        }

      });



      root.addEventListener('shopify:block:deselect', function () {

        if (!root._axiomSlideshow || !root._axiomSlideshow.autoplay || reducedMotion || root.dataset.autoplay !== 'true') return;

        root.classList.add('is-autoplaying');

        root._axiomSlideshow.autoplay.start();

        restartProgress(root);

      });

    }).catch(function (error) {

      console.warn('Slideshow could not load Swiper.', error);

      root.dataset.slideshowBound = 'false';

    });

  }



  function destroySlideshow(root) {

    if (!root) return;

    root.dataset.slideshowDestroyed = 'true';



    root.querySelectorAll('video').forEach(function (video) {

      video.pause();

    });



    if (root._axiomSlideshow && typeof root._axiomSlideshow.destroy === 'function') {

      root._axiomSlideshow.destroy(true, true);

    }



    delete root._axiomSlideshow;

    delete root.dataset.slideshowBound;

  }



  function initAll(scope) {

    scope = scope || document;

    if (scope.matches && scope.matches(SELECTOR)) {

      initSlideshow(scope);

      return;

    }

    scope.querySelectorAll(SELECTOR).forEach(initSlideshow);

  }



  window.AxiomSlideshow = {

    initAll: initAll,

    destroy: destroySlideshow

  };



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () {

      initAll(document);

    });

  } else {

    initAll(document);

  }



  document.addEventListener('shopify:section:load', function (event) {

    initAll(event.target);

  });



  document.addEventListener('shopify:section:unload', function (event) {

    event.target.querySelectorAll(SELECTOR).forEach(destroySlideshow);

  });



  if (DESKTOP_QUERY && typeof DESKTOP_QUERY.addEventListener === 'function') {

    DESKTOP_QUERY.addEventListener('change', function () {

      document.querySelectorAll(SELECTOR).forEach(function (root) {

        if (root._axiomSlideshow && typeof root._axiomSlideshow.update === 'function') {

          root._axiomSlideshow.update();

          updatePagination(root, root._axiomSlideshow);

        }

      });

    });

  }

})();
